export const TeamData = [
    {
        name: "Md. Milton Hossain",
        img: "milton.jpg",
        designation: "Software Engineer",
        facebook: "",
        github: "https://github.com/srmiltonkhan",
        linkedIn: "https://www.linkedin.com/in/srmiltonkhan/"
    },
    {
        name: "Md. Nasir Uddin",
        img: "",
        designation: "Web Designer",
        facebook: "",
        github: "",
        linkedIn: ""
    },
    {
        name: "Atikur Rahman",
        img: "",
        designation: "Database Enginner",
        facebook: "",
        github: "",
        linkedIn: ""
    },
    {
        name: "Md. Motaleb Hossain",
        img: "motaleb.png",
        designation: "Assistant Manager (MIS & IT)",
        facebook: "https://www.facebook.com/arifin.hossain.52",
        github: "https://github.com/motaleb1",
        linkedIn: "https://www.linkedin.com/in/mdmotalebhossain"
    },
];